// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar_container__Cdreq","desktopItems":"navbar_desktopItems__5Ru48","mobileItems":"navbar_mobileItems__33XwH","mobileMenu":"navbar_mobileMenu__Koxas"};